<template>
	<div class="pay-loan">
		<div class="pay-loan__form">
			<div class="pay-loan__cont-wrap">
				<div class="pay-loan__cont">
					<div class="pay-loan__title">
						<div class="pay-loan__title-icon">
							<img src="/local/templates/.default/img/svg/logo-icon.svg" alt="">
						</div>
						<span v-if="formStatus.sent && !formStatus.success">Залоговый билет не найден</span>
						<span v-else-if="payStatus.sent && !payStatus.isFinal">Ожидает оплаты</span>
						<span v-else-if="payStatus.sent && payStatus.isFinal && payStatus.succeeded">Оплата прошла</span>
						<span v-else-if="payStatus.sent && !payStatus.success">Оплата не прошла</span>
						<span v-else>Оплатить заём</span>

					</div>
					<div class="messages" v-if="!formStatus.sent || !formStatus.success">
						<template v-if="!formStatus.sent">
							<div class="messages__item">
								<p>Здесь вы можете узнать и оплатить текущую <br>задолженность по своему залоговому
									билету</p>
							</div>
							<div class="messages__item">
								<p>Для этого введите номер билета в поле <br>ниже и нажмите кнопку «Узнать
									задолженность»</p>
							</div>
							<div class="messages__item">
								<p><b>Помните, вы платите только за фактическое количество дней пользования займом</b></p>
							</div>

						</template>
						<template v-else-if="formStatus.sent && !formStatus.success">
							<div class="messages__item" v-if="formStatus.message">
								<p>{{ formStatus.message }}</p>
							</div>
							<div class="messages__item">
								<p>Возможно вы ошиблись при вводе данных, <br>попробуйте заполнить поле заново.</p>
							</div>
						</template>
					</div>

					<template v-if="payStatus.sent">
						<div class="messages">
							<div v-for="(message, index) in payStatus.messages" :key="index" class="messages__item">
								<p v-html="message"></p>
							</div>
						</div>

						<template v-if="payStatus.success">
							<div class="pay-loan__data">
								<div class="pay-loan__data-info">
									<div class="pay-loan__data-date">Сумма для выкупа залога</div>
									<div class="pay-loan__data-price">
										<div class="price">{{ ticketData['debt_main'] }} <i>₽</i></div>
									</div>
									<div class="pay-loan__data-desc pay-loan__data-additional">
										Мы проводим небольшой опрос.<br> Согласны принять участие? <br><br>
										<a class="btn white" target="_blank" href="https://anketolog.ru/nps_site">Пройти опрос</a>
									</div>
								</div>
								<!--                  <div class="pay-loan__data-important">Вы можете выкупить свой залог по адресу:-->
								<!--                    <br><span>г. Челябинск, ул. Кирова, 4</span></div>-->
							</div>

							<div class="pay-loan__btns">
								<button class="btn color" @click.prevent="refreshAll" tabindex="0">Вернуться к
									оплате задолженности
								</button>
							</div>
						</template>
						<div class="pay-loan__btns" v-else>
							<button class="btn color" @click.prevent="refreshPayment" tabindex="0">Попробовать
								заново
							</button>
							<button class="btn trans" @click.prevent="refreshAll" tabindex="0">Вернуться к оплате
							</button>
						</div>
					</template>

					<form v-if="!payStatus.sent" class="form pay-loan__form-form" action="" autocomplete="new-password">
						<div class="pay-loan__form-input">
							<template v-if="ticketsHistory.length">
								<div class="pay-loan__form-history" v-show="showHistory">
									<div class="requests">
										<div class="requests__label">История запросов</div>
										<div class="requests__list">
											<span v-for="(item, index) in ticketsHistory" :key="index" class="requests__item" @click.prevent.stop="ticketNum = item, showHistory = false">{{
													item
												}}</span>
										</div>
									</div>
								</div>
							</template>

							<div class="default-input">
								<label class="default-input__label" for="pform-ticket">Номер билета</label>
								<div class="default-input__input" :class="{'default-input__input--error' : v$.ticketNum.$errors.length}">
									<input @focus="showHistory = true" @blur="hideHistory()" @input="v$.$clearExternalResults(), v$.$reset()" autocomplete="off" type="text" v-model="ticketNum" inputmode="text" id="pform-ticket" placeholder="ФН123456" tabindex="0">
								</div>
								<div v-if="v$.ticketNum.$errors.length" class="default-input__error">
									<span v-for="(error, index) in v$.ticketNum.$errors" :key="index">{{ error.$message }}</span>
								</div>
							</div>
							<button @click.prevent="loadTicket" :disabled="loading" class="btn color" tabindex="0">
								Узнать задолженность
							</button>
						</div>

						<template v-if="formStatus.sent && formStatus.success">
							<div class="pay-loan__data">

								<div class="pay-loan__data-additional">
									<p class="pay-loan__data-notion">Внимание! при оплате кредитной картой возможна
										комиссия вашего банка. Для оплаты без комиссии воспользуйтесь СБП</p>
								</div>

								<div class="pay-loan__data-inner">
									<div class="pay-loan__data-title">Данные по задолженности</div>
									<div class="pay-loan__data-info">

										<div class="pay-loan__data-date">Задолженность по
											{{ ticketData['debt_percent'] > 0 ? '%' : 'займу' }}
											на<span>{{ new Date().toLocaleDateString() }}</span></div>

										<div class="pay-loan__data-price">
											<div class="price">
												{{ payTarget.value ? payTarget.value : ticketData['debt_percent'] }}
												<i>₽</i></div>

										</div>
									</div>
									<div class="pay-loan__data-total">
										<div class="pay-loan__data-item"><span>Сумма займа</span><span
											class="price">{{ ticketData['debt_main'] }} <i>₽</i></span></div>
										<div class="pay-loan__data-item"><span>Общая задолженность</span><span
											class="price">{{ ticketData['debt_total'] }} <i>₽</i></span></div>
									</div>
								</div>


							</div>

							<div class="pay-loan__sum" v-if="ticketData['debt_percent'] <= 0 && payTarget.value">
								<div class="range-block">
									<div class="default-input">
										<label class="default-input__label">Введите сумму для оплаты</label>
										<div class="default-input__input">
											<input type="number" placeholder="до 5000" v-model="amount">
										</div>
									</div>

									<Slider :tooltips="false" :lazy="false" v-model="amount" class="slider-range" :min="1" :max="payTarget.value"/>
								</div>

							</div>

							<div class="pay-loan__form-input">
								<div class="default-input">
									<label class="default-input__label" for="pform-email">E-mail для отправки
										чека</label>
									<div class="default-input__input" :class="{'default-input__input--error' : v$.email.$errors.length}">
										<input type="email" v-model="email" inputmode="email" id="pform-ticket" placeholder="mail@gmail.com" tabindex="0">
									</div>
									<div v-if="v$.email.$errors.length" class="default-input__error">
										<span v-for="(error, index) in v$.email.$errors" :key="index">{{ error.$message }}</span>
									</div>
								</div>
							</div>

							<div class="pay-loan__form-btns">
								<template v-if="!email">
									<button class="btn color" :disabled="true" tabindex="0">Укажите E-mail</button>
								</template>
								<template v-else-if="!payTarget.value">
									<button class="btn color" :disabled="true" tabindex="0">{{
											payTarget.name
										}}
									</button>
									<span class="pay-loan__form-btns--desc">Оплата по данному залоговому билету недоступна, пожалуйста, обратитесь в ломбард или на горячую линию</span>
								</template>
								<template v-else>
									<button v-for="(type, index) in payTarget.types" :key="index" class="btn color" :disabled="loading" @click.prevent="getPayLink(type.xml_id)" tabindex="0">{{ type.name || payTarget.name }}
									</button>
								</template>
							</div>
						</template>
					</form>
				</div>
			</div>
		</div>
		<PayLoanInfo/>
	</div>
</template>

<script>
import PayLoanInfo from "@/components/Pay/PayLoanInfo";
import useVuelidate from "@vuelidate/core";
import Slider from "@vueform/slider"
import {required, helpers, email, maxLength} from '@vuelidate/validators'
import {mapActions, mapGetters, mapMutations} from "vuex";
import {reactive} from "vue";

const {withMessage} = helpers
export default {
	name: "PayForm",
	components: {PayLoanInfo, Slider},
	setup() {
		const externalResults = reactive({})
		return {
			externalResults,
			v$: useVuelidate({$externalResults: externalResults})
		}
	},
	data() {
		return {
			loading: false,
			showHistory: false,
			userDataTrigger: null,
			ticketNum: '',
			amount: 1,
			email: '',
			formStatus: {
				sent: false,
				success: false,
				messages: '',
			},
			payStatus: {
				sent: false,
				timeout: null,
				success: false,
				succeeded: false,
				isFinal: false,
				messages: [],
			}
		}
	},
	validations() {
		return {
			ticketNum: {required: withMessage('Необходимо указать номер билета', required)},
			email: {
				email: withMessage('Неверный формат электронной почты', email),
				required: withMessage('Необходимо указать E-mail', required),
				maxLength: withMessage('Максимальная длина поля 100 символов', maxLength(100)),
			},
		}
	},
	watch: {
		payTarget: {
			handler: function (newValue) {
				if (newValue && newValue.value) this.amount = newValue.value
			},
			deep: true
		}
	},
	computed: {
		payTarget() {
			if (!this.ticketData) {
				return {
					name: 'Оплата недоступна',
					value: null,
					initial: null,
				}
			}

			if (this.ticketData['debt_percent'] > 0) {
				if (this.ticketData['debt_percent_available_to_pay'] < 1) {
					return {
						name: 'Оплата недоступна',
						value: null,
						initial: null,
					}
				} else {
					if (this.ticketData['types_to_pay']) {
						return {
							name: 'Оплатить проценты',
							value: this.ticketData['debt_percent_available_to_pay'],
							initial: this.ticketData['debt_percent_available_to_pay'],
							types: this.ticketData['types_to_pay']
						}
					} else {
						return {
							name: 'Оплата недоступна',
							value: null,
							initial: null,
						}
					}
				}
			} else {
				if (this.ticketData['debt_main_available_to_pay'] < 1) {
					return {
						name: 'Оплата недоступна',
						value: null,
						initial: null,
					}
				} else {
					if (this.ticketData['types_to_pay']) {
						return {
							name: 'Оплатить займ',
							value: this.ticketData['debt_main_available_to_pay'],
							initial: this.ticketData['debt_main_available_to_pay'],
							types: this.ticketData['types_to_pay']
						}
					} else {
						return {
							name: 'Оплата недоступна',
							value: null,
							initial: null,
						}
					}
				}
			}
		},
		...mapGetters({
			ticketData: 'debt/getTicketData',
			userData: 'user/getUserData',
			ticketsHistory: 'debt/getTicketsHistory'
		})
	},
	mounted() {
		this.setUserEmail();
	},
	methods: {
		setUserEmail() {
			if (this.userData) {
				this.email = this.userData.email
			} else {
				if (!this.userDataTrigger) {
					this.userDataTrigger = this.$watch('userData',  (newValue) => {
						this.email = newValue.email;
						this.userDataTrigger();
					})
				}
			}
		},
		refreshAll() {
			if (this.payStatus.timeout) {
				clearTimeout(this.payStatus.timeout)
			}

			this.payStatus = {
				sent: false,
				timeout: null,
				success: false,
				succeeded: false,
				isFinal: false,
				messages: [],
			}

			this.formStatus = {
				sent: false,
				success: false,
				timeout: null,
				messages: '',
			}

			this.ticketNum = ''

			this.clearTicketData()
		},
		refreshPayment() {
			if (this.payStatus.timeout) {
				clearTimeout(this.payStatus.timeout)
			}

			this.payStatus = {
				sent: false,
				timeout: null,
				success: false,
				succeeded: false,
				isFinal: false,
				messages: [],
			}
		},
		hideHistory() {
			if (this.showHistory) {
				setTimeout(() => this.showHistory = false, 1000)
			}
		},
		async getPayLink(payment_type) {
			this.loading = true
			const result = await this.v$.email.$validate()
			if (!result || !this.payTarget.value) {
				this.loading = false
				return
			}

			// eslint-disable-next-line
			window.sendYM('zakaz-oplata-procentov')

			let payLink = await this.loadPayLink({
				email: this.email,
				amount: this.ticketData['debt_percent'] > 0 ? String(this.payTarget.initial * 100) : String(this.amount * 100),
				payment_type: payment_type
			})
			if (payLink.success) {
				await this.checkPayStatus(payLink.data.transaction)
			} else {
				this.payStatus.success = false
				this.payStatus.messages.push(payLink.message)
			}
			this.payStatus.sent = true
			this.loading = false
		},
		async checkPayStatus(transaction) {
			let paymentStatus = await this.loadPaymentStatus({transaction: transaction})
			if (paymentStatus.success) {
				this.payStatus.messages = paymentStatus.data['messages']
				this.payStatus.isFinal = paymentStatus.data['is_final']
				this.payStatus.succeeded = paymentStatus.data['succeeded']
				if (!this.payStatus.isFinal) {
					this.payStatus.timeout = setTimeout(() => this.checkPayStatus(transaction), 2000)
				}
				if (this.payStatus.isFinal && !this.payStatus.succeeded) {
					this.payStatus.success = false
				} else {
					this.payStatus.success = true
					// eslint-disable-next-line
					window.sendYM('oplata-procentov')

				}
			} else {
				this.payStatus.success = false
				this.payStatus.messages = [paymentStatus.message]
			}
		},
		async loadTicket() {
			this.loading = true
			const result = await this.v$.ticketNum.$validate()
			if (!result) {
				this.loading = false
				return
			}

			// eslint-disable-next-line
			window.sendYM('uznat-zadolzhennost')


			let status = await this.loadTicketData({ticketNum: this.ticketNum})
			if (status.success) {
				this.formStatus.success = true
			} else {
				const errors = {
					ticketNum: 'Залоговый билет не найден'
				}
				Object.assign(this.externalResults, errors)
				this.formStatus.success = false
				this.formStatus.message = status.message
			}
			this.formStatus.sent = true
			this.loading = false
		},
		...mapActions({
			loadTicketData: 'debt/loadTicketData',
			loadPayLink: 'debt/loadPayLink',
			loadPaymentStatus: 'debt/loadPaymentStatus'
		}),
		...mapMutations({
			clearTicketData: 'debt/clearTicketData'
		})
	}
}
</script>

<style scoped>

</style>
